<!--推荐单位项目审核-->
<template>
    <el-dialog title="推荐审核" :visible.sync="dialogVisible" width="600px" :before-close="_handleClose">
        <!-- 保存提示 -->
        <div class="tipList">
            <el-form ref="inputForm" :model="formData" :rules="rules" label-width="90px" label-suffix=":">
                <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="审核建议" prop="auditSuggest">
                        <el-input v-model="formData.auditSuggest" type="textarea" :rows="5" placeholder="请输入内容"
                                  :disabled="false"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="审核结果" prop="auditResult">
                        <el-select v-model="formData.auditResult" placeholder="请选择审核结果" style="width: 100%">
                            <el-option label="同意推荐" value="同意"></el-option>
                            <el-option label="不同意推荐" value="不同意"></el-option>
                            <el-option label="退回修改" value="退回"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">返回</el-button>
			<el-button type="primary" @click="_submit">确认提交</el-button>
		</span>
    </el-dialog>
</template>

<script>
    import {applySubmit} from "@/api/modules/project";
    import {applyAuditSubmit} from "@/api/modules/project";

    export default {
        data() {
            return {
                dialogVisible: false,
                formData: {
                    prjApplyID: '',
                    auditSuggest: '',
                    auditResult: '同意'
                },
                //表单验证
                rules: {
                    auditSuggest: [{
                        required: true,
                        message: '必须录入',
                        trigger: 'blur'
                    }],
                    auditResult: [{
                        required: true,
                        message: '必须录入',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            showDialog(prjApplyID) {
                this.dialogVisible = true
                this.formData.prjApplyID = prjApplyID;
                this.formData.auditSuggest = ''
                this.formData.auditResult = '同意'
            },
            //审核提交
            _submit() {
                this.$confirm('确认提交?').then(() => {
                    applyAuditSubmit({
                        data: this.formData,
                        success: (res) => {
                            this.$message.success("审核完成");
                            this.$emit("dialogClose");
                            this._handleClose();
                        }
                    })
                })
            },
            /*对话框关闭*/
            _handleClose() {
                this.dialogVisible = false
            }
        }
    }
</script>

<style scoped="scoped">
    .el-dialog__header {
        height: 100px;
        line-height: 50px;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }

    .el-dialog {
        border-radius: 6px;
    }

    .tipList {
        width: 100%;
    }

    /* 保存提示 */
    .tipList p {
        line-height: 25px;
        text-align: left;
    }

    .tipList p:first-child {
        margin-bottom: 20px;
    }

</style>